/** Normalize email for API/DB lookups (trim + lowercase) — matches Ringo Hub. */
export function normalizeUserEmail(email) {
  if (email == null) return '';
  return String(email).trim().toLowerCase();
}

/**
 * Derive a display name from an email local-part.
 * e.g. jane.doe@ringcentral.com → "Jane Doe"
 * @param {string} email
 * @returns {string}
 */
export function displayNameFromEmail(email) {
  const local = String(email || '').split('@')[0].trim();
  if (!local) return '';
  return local
    .split(/[._+\-]+/)
    .filter(Boolean)
    .map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase())
    .join(' ');
}

/**
 * Prefer stored name; otherwise derive from email.
 * @param {{ userName?: string, userEmail?: string } | string} userOrName
 * @param {string} [email]
 * @returns {string}
 */
export function resolveUserDisplayName(userOrName, email) {
  if (userOrName && typeof userOrName === 'object') {
    const name = String(userOrName.userName || '').trim();
    if (name) return name;
    return displayNameFromEmail(userOrName.userEmail) || String(userOrName.userEmail || '');
  }
  const name = String(userOrName || '').trim();
  if (name) return name;
  return displayNameFromEmail(email) || String(email || '');
}
